import { Elements } from '@/components/elements';
import clsx from 'clsx';
import Image from 'next/image';

export type TrojanHorseCard = {
    iconSrc: string;
    iconAlt?: string;
    title: string;
    description: string;
};

export type TrojanHorseSectionProps = {
    cards: TrojanHorseCard[];
    className?: string;
};


export function TrojanHorseSection({
    cards,
    className,
}: TrojanHorseSectionProps) {
    return (
        <section
            className={clsx(
                'overflow-hidden px-5 py-16 md:px-10 md:py-20 lg:px-[79px]',
                className,
            )}
        >
            <div
                className={clsx(
                    'mx-auto flex w-full max-w-[1280px] flex-col gap-8 rounded-[40px] bg-gray-100 p-16',
                    // Dot grid on gray-100
                    'bg-[radial-gradient(circle_at_center,rgb(209_213_219)_1px,transparent_1.5px)]',
                    'bg-size-[22px_22px]',
                )}
            >
                <div className="flex flex-col items-center gap-4 text-center">
                    <span
                        className={clsx(
                            'inline-flex rounded-lg bg-gray-200 px-2 py-1 text-base font-medium tracking-[0.12em] text-gray-500 uppercase',
                        )}
                    >
                        PROBLEM
                    </span>
                    <Elements.Title
                        title='The "Trojan Horse" Vendor'
                        type="h2"
                        className="max-w-[920px] text-3xl font-semibold md:text-4xl"
                    />
                    <Elements.Description
                        description='A brokerage firm initially looked at "Big Tech" ICHRA platforms. However, they quickly hit three major roadblocks:'
                        type="medium"
                        className="text-balance text-gray-700"
                    />
                </div>
                <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-3 md:gap-5 lg:gap-6">
                    {cards.map((card, index) => (
                        <div
                            key={`${card.title}-${index}`}
                            className="rounded-2xl bg-gray-100 p-2 shadow-[0px_0px_4px_0px_#0000001F_inset]"
                        >
                            <div className="flex h-full w-full flex-col gap-3 rounded-2xl border border-gray-200/80 bg-white p-4 shadow-[0px_0px_5px_0px_#00000017,2px_2px_7px_0px_#0000000D]">
                                <div className="flex items-center  gap-4">
                                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#FFF0F1]">
                                        <Image
                                            src={card.iconSrc}
                                            alt={card.iconAlt ?? ''}
                                            width={28}
                                            height={28}
                                            className="h-7 w-7 object-contain"
                                        />
                                    </div>
                                    <Elements.Title
                                        title={card.title}
                                        type="h5"
                                        className="min-w-0 flex-1 text-left text-lg! font-semibold text-gray-900 md:text-xl!"
                                    />
                                </div>
                                <Elements.Description
                                    description={card.description}
                                    type="small"
                                    className="w-full text-left text-gray-600"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
